import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { getPostTemplatesApi } from "../../api/postTemplateService";
import Pagination from "../../components/Pagination/Pagination";
import SearchInput from "../../common/SearchInput";
import Button from "../../utils/Buttons";
import { FiPlus } from "react-icons/fi";
const formatDateForInput = (isoString) => {
  if (!isoString) return "";
  const [day, month, yearTime] = isoString.split("-");
  const year = yearTime.split(" ")[0];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthShort = months[parseInt(month) - 1];
  return `${day}th ${monthShort} ${year}`;
};
class PostTemplatesList extends Component {
  state = {
    posts: [],
    loading: true,
    error: null,
    itemsPerPage: 9,
    currentPage: 1,
    totalItems: 0,
    showModal: false,
    modalImage: null,
    filter: "All",
    search: "",
    toastMessage: "",
    toastType: "success",
  };
  componentDidMount() {
    const { location, navigate } = this.props;
    if (location?.state?.toastMessage) {
      this.setState({
        toastMessage: location.state.toastMessage,
        toastType: location.state.toastType || "success",
      });
      setTimeout(() => {
        this.setState({ toastMessage: "" });
      }, 5000);
      setTimeout(() => {
        this.fetchPostTemplates();
      }, 400);
      navigate("/banner-images", { replace: true });
    } else {
      this.fetchPostTemplates();
    }
  }
  fetchPostTemplates = async () => {
    const { currentPage, itemsPerPage } = this.state;

    try {
      this.setState({
        loading: true,
        error: null,
      });

      const response = await getPostTemplatesApi({
        page: currentPage,
        limit: itemsPerPage,
      });

      const normalizedPosts = (response?.data || []).map((item) => ({
        ...item,

        status: item.status ? item.status.toUpperCase() : "",

        // category is an object in your API response
        category: item.category?.name ? item.category.name.toUpperCase() : "",
      }));

      this.setState({
        posts: normalizedPosts,
        totalItems: response?.pagination?.totalItems || 0,
        loading: false,
      });
    } catch (error) {
      console.error("Failed to load templates:", error);

      this.setState({
        posts: [],
        error:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to load templates",
        loading: false,
      });
    }
  };
  handlePageChange = (pageNum) => {
    this.setState(
      { currentPage: pageNum, loading: true },
      this.fetchPostTemplates,
    );
  };
  handleFilterChange = (e) => {
    this.setState({ filter: e.target.value, currentPage: 1 });
  };
  handleSearchChange = (value) => {
    this.setState({ search: value, currentPage: 1 });
  };
  openImageModal = (image) => {
    this.setState({ showModal: true, modalImage: image });
  };
  closeImageModal = () => {
    this.setState({ showModal: false, modalImage: null });
  };
  render() {
    const { fixNavbar, navigate } = this.props;
    const {
      posts,
      loading,
      error,
      itemsPerPage,
      currentPage,
      totalItems,
      showModal,
      modalImage,
      filter,
      search,
      toastMessage,
      toastType,
    } = this.state;
    if (loading)
      return (
        <div className="d-flex vh-100 w-100 align-items-center justify-content-center">
          <p className="m-0">Loading templates...</p>
        </div>
      );
    if (error) return <p className="error text-center mt-5">{error}</p>;
    const filteredPosts = posts.filter((post) => {
      const matchesStatus =
        filter === "All" || post.status === filter.toUpperCase();
      const matchesSearch =
        post.name?.toLowerCase().includes(search.toLowerCase()) ||
        post.category?.toLowerCase().includes(search.toLowerCase());
      return matchesStatus && matchesSearch;
    });
    return (
      <div className={`${fixNavbar ? "marginTop" : ""}`}>
        {/* CUSTOM TOAST */}
        {toastMessage && (
          <div
            style={{
              position: "fixed",
              top: "100px",
              right: "100px",
              padding: "12px 20px",
              borderRadius: "6px",
              color: "#fff",
              backgroundColor: toastType === "success" ? "#18cb96" : "#dc3545",
              zIndex: 9999,
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            {toastMessage}
          </div>
        )}
        <div className="container p-4 np-banners-page">
          {/* HEADER */}
          <div className="row mb-3 align-items-center justify-content-end">
            <div className="col-md-3">
              <SearchInput
                value={search}
                onChange={this.handleSearchChange}
                placeholder="Search by name / category"
              />
            </div>
            <div className="col-md-2">
              <select
                className="form-control text-dark"
                value={filter}
                onChange={this.handleFilterChange}
              >
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <div className="col-md-2 text-right">
              <Button
                text="Add New"
                icon={<FiPlus size={15} />}
                onClick={() => navigate("/banner-templates/add")}
                className="btn btn-primary"
              />
            </div>
          </div>
          {/* CARDS */}
          <div className="row row-cards">
            {filteredPosts.length === 0 && (
              <p className="ml-3">No templates found</p>
            )}
            {filteredPosts.map((post) => (
              <div key={post._id} className="col-sm-6 col-lg-4">
                <div className="card p-2">
                  <div style={{ position: "relative" }}>
                    <img
                      src={post.imageUrl}
                      alt={post.name}
                      className="card-img-top"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <Button
                      icon={<i className="fe fe-edit" title="Edit"></i>}
                      onClick={() =>
                        navigate("/banner-templates/edit", {
                          state: { postId: post._id },
                        })
                      }
                      className="btn btn-sm btn-outline-light icon1"
                    />
                    <Button
                      icon={<i className="fe fe-eye" title="View"></i>}
                      onClick={() => this.openImageModal(post.imageUrl)}
                      className="btn btn-sm btn-outline-light icon2"
                    />
                  </div>
                  <h6 className="text-2-line pt-2">{post.name}</h6>
                  <div>
                    <i className="fe fe-calendar text-dark mr-1"></i>
                    {formatDateForInput(post.fromDate)}
                  </div>
                  <div>
                    <i className="fe fe-calendar text-dark mr-1"></i>
                    {formatDateForInput(post.toDate)}
                  </div>
                  <div className="d-flex align-items-center mt-2">
                    {post.category && (
                      <Button
                        text={post.category}
                        className={`badge ${
                          post.category === "Mural"
                            ? "badge-info"
                            : "badge-success"
                        } border-0 p-2 mr-2 `}
                      />
                    )}
                    <Button
                      text={post.status}
                      className={`badge ${
                        post.status === "ACTIVE"
                          ? "badge-success"
                          : "badge-danger"
                      } p-2  border-0`}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* PAGINATION */}
          <Pagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={this.handlePageChange}
          />
          {/* IMAGE MODAL */}
          {showModal && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)" }}
            >
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Image Preview</h5>
                    <button className="close" onClick={this.closeImageModal}>
                      <span>&times;</span>
                    </button>
                  </div>
                  <div className="modal-body text-center">
                    <img
                      src={modalImage}
                      alt="Preview"
                      className="img-fluid rounded"
                      style={{ maxHeight: "70vh", border: "1px solid black" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});
export default connect(mapStateToProps)(withRouter(PostTemplatesList));
